<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8"
          :collapse-action="true">
          <div class="vx-row mb-3">

            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">General Search</label>
              <vs-input type="text" class="w-full" v-model="filters['search']" @input="search" />
            </div>
            
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
              <div class="p-2 border border-solid d-theme-border-grey-light rounded">
                <label class="text-sm opacity-100 text-bold mb-1 block">Batch Booking Date</label>
                  <div class="vx-row">
                    <div class="vx-col w-1/2">
                      <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['from_manu_date']"
                        placeholder="From" @input="search" />
                    </div>
                    <div class="vx-col w-1/2">
                      <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['to_manu_date']"
                        placeholder="To" @input="search" />
                    </div>
                  </div>
              </div>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
              <div class="p-2 border border-solid d-theme-border-grey-light rounded">
                <label class="text-sm opacity-100 text-bold mb-1 block">Date Added to WIP</label>
                <div class="vx-row">
                  <div class="vx-col w-1/2">
                    <flat-pickr
                      class="w-full"
                      :config="{ dateFormat: 'd/m/Y'}"
                      v-model="filters['batch-mixed-from']"
                      placeholder="From"
                      @input="search"
                    />
                  </div>
                  <div class="vx-col w-1/2">
                    <flat-pickr
                      class="w-full"
                      :config="{ dateFormat: 'd/m/Y'}"
                      v-model="filters['batch-mixed-to']"
                      placeholder="To"
                      @input="search"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <div class="flex items-center  mt-6">
                <span class="text-sm mr-2" :class="!filters['non_zero'] ? 'text-primary' : ''">
                  Show all
                </span>

                <vs-switch v-model="filters['non_zero']" @input="search" />

                <span class="text-sm ml-2" :class="filters['non_zero'] ? 'text-primary' : ''">
                  Show only non zero records
                </span>
              </div>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                @click="onClickClearSearch">CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
        <vx-card v-if="is_loaded" title="Mass Balance Report">
          <vs-table :max-items="(meta.per_page) ? meta.per_page : 10" stripe :data="mass_balance_data" :sst="true"
            class="table-dark-inverted table-auto vs-con-loading__container" id="mass-balance-audit-table">
            <template slot="thead">
              <vs-th width="10%">RM Code</vs-th>
              <vs-th width="10%">RM NAME</vs-th>
              <vs-th width="10%">RM ORDER CODE</vs-th>
              <vs-th width="20%">BATCH CODE</vs-th>
              <vs-th width="10%" class="th-right">MASS BALANCE(KG)</vs-th>
              <vs-th width="10%" class="th-right">AVAILABLE QUANTITY (KG)</vs-th>
              <vs-th width="10%" class="th-right">TOTAL QUANTITY RECEIVED (KG)</vs-th>
              <vs-th width="10%">SUPPLIER BATCH NUMBER</vs-th>
              <vs-th width="10%">SUPPLIER</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data"
                @click.native.stop="loadExpandedData(tr, indextr)">

                <vs-td>
                  {{ tr.raw_material_code }}
                </vs-td>
                <vs-td>
                  {{ tr.raw_material_name }}
                </vs-td>
                <vs-td>
                  <vx-tooltip text="View RM Order" position="top">
                    <span v-if="hasRawMaterialOrder(tr)" class="text-primary cursor-pointer"
                      @click.stop="viewRawMaterialOrder(tr)">
                      {{ getPurchaseOrderCode(tr) }}
                    </span>

                    <span v-else>
                      —
                    </span>
                  </vx-tooltip>
                </vs-td>
                <vs-td>
                  {{ tr.batch_code }}
                </vs-td>
                <vs-td class="td-right text-right font-bold">
                  {{ tr.quantity_discrepancy }}
                </vs-td>
                <vs-td class="td-right text-right">
                  {{ tr.available_quantity }}
                </vs-td>
                <vs-td class="td-right text-right">
                  {{ tr.total_quantity }}
                </vs-td>
                <vs-td>
                  {{ tr.supplier_batch_no }}
                </vs-td>
                <vs-td>
                  {{ tr.supplier }}
                </vs-td>

                <!-- <template class="expand-user" slot="expand">
            <div class="con-expand-users w-full px-8">

              <div class="vx-row mt-8 mb-2">
                <h5 class="mb-4 px-4 text-warning">RM ORDER ITEM DETAILS</h5>
              </div>

              <div class="grid grid-cols-3 gap-2 mb-8">
                <div>Order Item Quantity (KG): {{ tr.raw_material_order_item.quantity }}</div>
                <div>Batch Quantity (KG): {{ tr.total_quantity }}</div>
                <div>Quantity Pending to Receive (KG): {{ tr.raw_material_order_item.quantity_pending_to_receive }}</div>
                <div>Price (GBP): {{ tr.raw_material_order_item.gbp_price }}</div>
                <div>Order Item Status: {{ tr.raw_material_order_item.item_status }}</div>
                <div>Added to Stock: {{ tr.raw_material_order_item.is_added_to_stock ? 'Yes' : 'No' }}</div>
              </div>

              <div class="grid grid-cols-1 gap-1 mb-8">
                <div>Quantity ordered of this RM (KG): {{ toFormatDecimals(tr.raw_material_order_item.quantity) }}</div>
                <div>Quantity received and added to batch in stock (KG): {{ toFormatDecimals(tr.raw_material_order_item.quantity - tr.raw_material_order_item.quantity_pending_to_receive) }}</div>
                <div>SO dispatched to customer (KG): {{ toFormatDecimals(soDispatchedToCustomer(tr.work_orders)) }}</div>
                <div>SO not dispatched (KG): {{ toFormatDecimals(soNotDispatchedToCustomer(tr.work_orders)) }}</div>
                <div>WO made for stock FG (KG): {{ toFormatDecimals(woMadeForStock(tr.work_orders)) }}</div>
                <div>RM stock (KG): {{ toFormatDecimals(tr.available_quantity) }}</div>
                <div>RM waste management (KG): {{ toFormatDecimals(rmWasteManagement(tr.waste)) }} </div>
                <div>Product waste management (KG): {{ toFormatDecimals(workOrderWaste(tr.work_orders)) }} </div>
                <div class="text-primary text-bold">Mass balance discrepancy (KG): {{ massBalanceDiff(tr.work_orders, tr.waste, tr.available_quantity, tr.total_quantity, tr.raw_material_order_item.quantity_pending_to_receive) }} </div>
              </div> -->

              </vs-tr>
            </template>

          </vs-table>
          <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
            :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
            description :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
            v-model="page" class="p-5">
          </vs-pagination>
        </vx-card>
      </div>
      <RMMassBalanceDetailViewPopUp ref="rmMassBalanceDetailViewPopUp" />
    </div>
  </div>

</template>

<script>

import { RepositoryFactory } from "@/repository/RepositoryFactory";
import { defaultPagination, perPageList } from "@/constants/config";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import ErrorMessages from "@/mixins/ErrorMessages";
import YesNoToggle from "@/components/yes-no-toggle/YesNoToggle.vue"
import RMMassBalanceDetailViewPopUp from '@/components/popups/mass-balance/rmMassBalanceDetailViewPopUp.vue'
const ReportingRepository = RepositoryFactory.get('reporting')

export default {
  name: "MassBalanceAudit",
  data() {
    return {
      mass_balance_data: [],
      meta: {},
      maxItems: 20,
      page: 1,
      total: 0,
      sort: 'quantity_discrepancy',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      filters: {
        search: '',
        from_manu_date: '',
        to_manu_date: '',
        non_zero: true,
        'batch-mixed-from': '',
        'batch-mixed-to': ''
      },
      is_loaded: false,
    }
  },
  computed: {
    filterQuery() {
      const search = this.filters.search || ''
      const from = this.filters.from_manu_date || ''
      const to = this.filters.to_manu_date || ''
      const batchMixedFrom = this.filters['batch-mixed-from'] || ''
      const batchMixedTo = this.filters['batch-mixed-to'] || ''
      const sort = this.sort || 'quantity_discrepancy'
      const nonZero = (this.filters.non_zero !== undefined && !this.filters.non_zero) ? 0 : 1

      return `filter[search]=${search}&filter[from]=${from}&filter[to]=${to}&filter[batch-mixed-from]=${batchMixedFrom}&filter[batch-mixed-to]=${batchMixedTo}&sort=${sort}&filter[non-zero]=${nonZero}`
    }
  },
  components: {
    flatPickr,
    'v-select': vSelect,
    YesNoToggle,
    RMMassBalanceDetailViewPopUp,
  },
  mixins: [ErrorMessages],
  async mounted() {
    await this.getMasBalanceReportData()
  },
  methods: {
    async getMasBalanceReportData() {
      try {
        this.is_loaded = false
        this.mass_balance_data = []
        await this.$vs.loading()
        const { data } = await ReportingRepository.getMassBalanceDataV2(this.page, this.filterQuery, this.perPage)
        this.mass_balance_data = data.data
        this.meta = data.meta
        this.is_loaded = true
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    filterQueryUpdate() {
      this.page = 1
      this.getMasBalanceReportData()
    },
    async loadExpandedData(row) {
      try {
        this.$refs.rmMassBalanceDetailViewPopUp.openPopup({
          row: row,
        }, row.inventory_id)

      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async onClickClearSearch() {
      this.filters = {
        search: '',
        from_manu_date: '',
        to_manu_date: '',
        non_zero: true,
        'batch-mixed-from': '',
        'batch-mixed-to': ''
      }
      this.filterQueryUpdate()
    },
    async onClickOrderDetailsView(id) {
      let route = this.$router.resolve({ path: `/pages/product-orders/${id}` });
      window.open(route.href, '_blank');
    },
    async onClickFormulationView(id) {
      let route = this.$router.resolve({ path: `/pages/formulations/${id}` });
      window.open(route.href, '_blank');
    },
    async onClickWorkOrderView(id) {
      let route = this.$router.resolve({ path: `/pages/manufacturing/work-orders/${id}/details` });
      window.open(route.href, '_blank');
    },
    async onClickRawMaterialOrderView(id) {
      let route = this.$router.resolve({ path: `/pages/raw-materials/orders/${id}` });
      window.open(route.href, '_blank');
    },
    changePage(index) {
      this.page = 1
      this.perPage = this.descriptionItems[index]
    },
    toFormatDecimals(value) {
      return Number(value).toFixed(4)
    },
    soDispatchedToCustomer(work_orders) {
      return work_orders.reduce((acc, cur) => {
        return acc + cur.stock.filter((x) => x.made_for !== 'Stock' && ['Dispatched', 'Customer-Received'].includes(x.item_status))
          .reduce((a, c) => a + parseFloat(c.rm_quantity), 0);
      }, 0);
    },
    soNotDispatchedToCustomer(work_orders) {
      return work_orders.reduce((acc, cur) => {
        return acc + cur.stock.filter((x) => x.made_for !== 'Stock' && !['Dispatched', 'Customer-Received'].includes(x.item_status))
          .reduce((a, c) => a + parseFloat(c.rm_quantity), 0);
      }, 0);
    },
    workOrderWaste(work_orders) {
      return work_orders.reduce((acc, cur) => {
        return acc + cur.waste.reduce((a, c) => a + parseFloat(c.rm_quantity), 0);
      }, 0);
    },
    woMadeForStock(work_orders) {
      return work_orders.reduce((acc, cur) => {
        return acc + cur.stock.filter((x) => x.made_for === 'Stock')
          .reduce((a, c) => a + parseFloat(c.rm_quantity), 0);
      }, 0);
    },
    rmWasteManagement(waste) {
      return waste.reduce((a, c) => a + parseFloat(c.quantity), 0)
    },
    massBalanceDiff(work_orders, waste, available_quantity, quantity, quantity_pending_to_receive) {
      let total = (quantity) - (this.soDispatchedToCustomer(work_orders) + this.soNotDispatchedToCustomer(work_orders) +
        this.woMadeForStock(work_orders) + this.workOrderWaste(work_orders) + this.rmWasteManagement(waste) + parseFloat(available_quantity))
      return Number(total).toFixed(4)
    },
    hasRawMaterialOrder(tr) {
      return !!(
        tr &&
        tr.raw_material_order_item &&
        tr.raw_material_order_item.staff_raw_material_order
      );
    },

    search: _.debounce(async function () {
      this.filterQueryUpdate()
    }, 600),

    getPurchaseOrderCode(tr) {
      if (!this.hasRawMaterialOrder(tr)) return '';

      return tr.raw_material_order_item
        .staff_raw_material_order
        .purchase_order_code;
    },

    viewRawMaterialOrder(tr) {
      if (!this.hasRawMaterialOrder(tr)) return;

      const id = tr.raw_material_order_item
        .staff_raw_material_order
        .id;

      this.onClickRawMaterialOrderView(id);
    }
  },
  watch: {
    page() {
      this.getMasBalanceReportData()
    },
    perPage() {
      this.getMasBalanceReportData()
    }
  }
}
</script>

<style scoped>
::v-deep #mass-balance-audit-table th.th-right .vs-table-text {
  justify-content: flex-end;
  text-align: right;
}
::v-deep #mass-balance-audit-table td.td-right {
  text-align: right;
}
</style>
